export default __webpack_public_path__ + "static/gsuite-2a237f1bea9e25b9728f3c5ccda70324.jpg";